import { TypedUseSelectorHook, useSelector } from "react-redux";
import store from "../../redux/store";

export type AppState = ReturnType<typeof store.getState>;
// eslint-disable-next-line import/prefer-default-export
export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;
